<script setup>
import Stars from "common/vue/components/Stars.vue";

const props = defineProps({
  review: {
    type: Object,
    required: true
  },
  toggleTooltip: {
    type: Function,
    required: true
  }
});
const { review, toggleTooltip } = props;
</script>

<template>
  <div class="pdp-made-review" @click="toggleTooltip">
    <div class="pdp-made-review__side pdp-made-review__side--image">
      <div class="pdp-made-review__image-wrap">
        <img alt="Review photo" class="pdp-made-review__image" :src="review.image" />
      </div>
    </div>
    <div class="pdp-made-review__side pdp-made-review__side--data">
      <header class="pdp-made-review__header">
        <Stars class="pdp-made-review__stars" :stars="review.rating" size="XS"></Stars>
        <span class="pdp-made-review__author">From {{ review.name }}, {{ review.created_at }}</span>
      </header>

      <h4 class="pdp-made-review__title">{{ review.title }}</h4>
      <p class="pdp-made-review__content">{{ review.review }}</p>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

.pdp-made-review {
  display: flex;
  gap: 8px;
  padding: 8px;
  border: 1px solid $gray-border;
  border-radius: 6px;
  background-color: $white;
  color: $dark-gray-link;

  @include with-tablet {
    gap: 16px;
  }

  &__image-wrap {
    flex-shrink: 0;
    width: 100px;
    height: 100px;
  }

  &__image {
    width: 100%;
    height: 100%;
    border-radius: 3px;
    object-fit: cover;
  }

  &__header {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 5px;
    padding-top: 4px;

    @include with-large-mobile {
      flex-direction: row;
    }
  }

  &__stars {
    margin-left: -7px;
    transform: scale(0.9);
  }

  &__author {
    display: block;
    color: $retail-price;
    font-size: 11px;
    white-space: nowrap;

    @include with-tablet {
      font-size: 12px;
    }
  }

  &__title {
    margin: 0;
    font-size: 16px;
    line-height: 1.4;
  }

  &__content {
    margin: 0;
    font-size: 12px;
    line-height: 1.2;
  }
}
</style>
